import { Relatorio } from "./relatorio";

/**
 * detalhes de um log de visualização de algum relatório
 *
 * @since 20230818
 */
export class LogVisualizacaoRelatorio {
  IdLogVisualizacao: number;
  DataVisualizacao: Date;
  IdRelatorio: number;

  CpfUsuario?: string;
  DataConfirmacao?: Date;
  IdLrf?: number;
  IdPca?: number;
  IdPcm?: number;
  IdRelatorioNavigation?: Relatorio;

  tratarDadosDaAPI(): void {
    if (this.DataVisualizacao) {
      this.DataVisualizacao = new Date(this.DataVisualizacao);
    }
    if (this.DataConfirmacao) {
      this.DataConfirmacao = new Date(this.DataConfirmacao);
    }
  }

  getConfirmacaoLeitura(): string {
    if (!this.DataConfirmacao || !this.CpfUsuario) return "";
    return `Visualização confirmada pelo CPF ${
      this.CpfUsuario
    } em ${this.DataConfirmacao.toLocaleDateString()}.`;
  }
}
